import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/concepts';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CONCEPTS);

export const useConcepts = (sessionToken) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: () => Client.fetchAll(sessionToken),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
